const carouselItems = [
  {
    title: '顶流明星深夜聚餐密会，经纪人紧急回应',
    excerpt: '近日有媒体拍到某顶流艺人深夜与神秘女子共进晚餐，两人举止亲密引发热议。经纪人火速发文否认，称只是普通朋友聚会。吃瓜群众纷纷表示坐等后续发展。',
    tag: '恋情瓜',
    img: 'https://readdy.ai/api/search-image?query=Cinema%20movie%20premiere%20scene%20with%20warm%20coral%20and%20amber%20spotlights%2C%20red%20carpet%20aesthetic%2C%20dramatic%20theatrical%20lighting%2C%20editorial%20style%20illustration%2C%20soft%20gradients%2C%20modern%20composition&width=800&height=500&seq=carousel-item-1&orientation=landscape',
  },
  {
    title: '知名综艺节目录制现场失控，导演当场发飙',
    excerpt: '某王牌综艺最新一期录制过程中，嘉宾互动环节突发失控场面，导致导演情绪激动当场中断录制。节目组随后发布声明表示将调整播出计划，相关片段可能被删减。',
    tag: '综艺瓜',
    img: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20warm%20golden%20spotlights%2C%20abstract%20musical%20elements%2C%20dramatic%20atmosphere%2C%20editorial%20illustration%20style%2C%20soft%20amber%20gradients%2C%20modern%20minimal%20design&width=800&height=500&seq=carousel-item-2&orientation=landscape',
  },
  {
    title: '网传某古装剧女主临时换角，片方三缄其口',
    excerpt: '备受期待的古装大剧传出女主换角消息，原定女主角因档期冲突或将退出，片方至今未作正面回应。网友扒出多个疑似新女主候选名单，各大粉丝群已开始激烈讨论。',
    tag: '影视瓜',
    img: 'https://readdy.ai/api/search-image?query=TV%20show%20drama%20production%20scene%20with%20warm%20theatrical%20lighting%2C%20abstract%20stage%20and%20spotlight%20motifs%2C%20editorial%20illustration%2C%20coral%20and%20golden%20accents%2C%20modern%20composition&width=800&height=500&seq=carousel-item-3&orientation=landscape',
  },
  {
    title: '某男星被拍与女助理同游日本，双方沉默',
    excerpt: '有网友在日本东京偶遇某知名男星与女助理同游，两人互动自然被疑关系不一般。截至目前双方均未回应此事，粉丝后援会则表示"等待官方消息，不信谣不传谣"。',
    tag: '恋情瓜',
    img: 'https://readdy.ai/api/search-image?query=Celebrity%20fashion%20editorial%20style%20illustration%20with%20warm%20peach%20and%20coral%20tones%2C%20abstract%20luxury%20aesthetic%2C%20soft%20gradients%2C%20modern%20minimal%20composition%2C%20elegant%20atmosphere&width=800&height=500&seq=carousel-item-4&orientation=landscape',
  },
  {
    title: '某歌手新专辑疑似抄袭海外作品，乐评人开撕',
    excerpt: '某人气歌手发布新专辑后，被多位乐评人指出主打歌曲调与某海外热门单曲高度相似。粉丝和路人在评论区展开激烈辩论，目前该歌手及经纪公司未对此事发表声明。',
    tag: '争议瓜',
    img: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20topic%20visualization%20with%20warm%20coral%20and%20amber%20gradients%2C%20abstract%20digital%20viral%20content%20aesthetic%2C%20editorial%20illustration%20style%2C%20modern%20clean%20composition&width=800&height=500&seq=carousel-item-5&orientation=landscape',
  },
  {
    title: '某剧组杀青宴上演全武行，多方说法不一',
    excerpt: '某热门剧组杀青宴上，两位主演因番位问题爆发激烈冲突，据目击者称现场一度失控。剧组官微发布声明称"拍摄顺利杀青"，但对冲突只字未提，引发更多猜测。',
    tag: '剧组瓜',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20studio%20atmosphere%20with%20warm%20golden%20stage%20lights%2C%20abstract%20theatrical%20elements%2C%20entertainment%20production%20aesthetic%2C%20editorial%20illustration%2C%20soft%20coral%20gradients&width=800&height=500&seq=carousel-item-6&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点大瓜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">本周最受关注的六大吃瓜事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.excerpt}</p>
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>2026-07-{27 + idx}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>{(8 + idx * 3)}.{(idx + 1) * 2}w 阅读
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}